<template>
  <div>
    <b-container class="m-0 p-0" fluid>
      <b-modal centered id="modal-schedule" hide-footer>
        <template v-slot:default>
          <div class="">
            <form @submit.prevent="addSched">
              <b-form-group>
                <b-form-group>
                  <p class="fll">Select Category</p>
                  <b-form-select
                    v-model="schedule.category"
                    :options="categoryarray"
                    @change="categoryChanged"
                  >
                    <b-form-select-option value="null" v-if="plan != 'Premium'"
                      >--Select category--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group v-if="sameName != 'Yes'">
                  <p class="fll">Institution</p>
                  <b-form-select
                    v-model="schedule.institution"
                    :options="institutionsarray"
                    @change="institutionChanged"
                  >
                    <b-form-select-option value="null" v-if="plan != 'Premium'"
                      >--Select Institution--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  v-if="structure == 'Section' && schedule.institution != null"
                  label="Level"
                  label-for="institution"
                >
                  <b-form-select
                    v-model="schedule.level"
                    @change="chgcourses"
                    :options="levelsarray"
                  >
                    <b-form-select-option value="null"
                      >--Select Level--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  v-if="
                    structure == 'Section' &&
                      schedule.institution != null &&
                      schedule.level != null
                  "
                  label="Select Course"
                  label-for="institution"
                >
                  <b-form-select
                    v-model="schedule.course"
                    :options="coursesarray"
                  >
                    <b-form-select-option value="null"
                      >--Select Course--</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  v-if="schedule.course != null || schedule.institution != null"
                  label="Select Test Mode"
                  label-for="testmode"
                >
                  <b-form-select
                    v-model="schedule.mode"
                    :options="testmodearray"
                  ></b-form-select>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  v-if="schedule.mode == 'Flexible'"
                  label="Select Test Reducer(in percentage)"
                  label-for="testmode"
                >
                  <b-form-spinbutton
                    id="totalque"
                    v-model="schedule.reducer"
                    min="25"
                    max="75"
                    step="25"
                  ></b-form-spinbutton>
                </b-form-group>

                <b-form-group
                  id="selsub"
                  label=""
                  label-size="lg"
                  class="nested-form-group"
                  v-if="structure == 'Subject'"
                >
                  <h5>
                    Select Subject Combination (Maximum of
                    {{ numberofSubjects }})
                  </h5>
                  <span>Please select the right subject combination</span>
                  <b-form-checkbox-group
                    id="selectsubject"
                    v-model="schedule.subjects"
                    :options="subjectsarray"
                    @change="topicMode"
                    name="subjectspo"
                    stacked
                    :state="substate"
                  >
                    <b-form-invalid-feedback :state="substate"
                      >Please Select exactly
                      {{ schedule.mode == "Topic" ? 1 : numberofSubjects }}
                      subject(s) to Proceed</b-form-invalid-feedback
                    >
                    <b-form-valid-feedback :state="substate"
                      >{{
                        schedule.mode == "Topic" ? 1 : numberofSubjects
                      }}
                      Subject(s) Selected Successfully,
                      Proceed.</b-form-valid-feedback
                    >
                  </b-form-checkbox-group>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  v-if="schedule.mode == 'Topic' && schedule.topics.length != 0"
                  label="Select No of Questions per Topic"
                  label-for="testmode"
                >
                  <b-form-spinbutton
                    id="modeque"
                    v-model="schedule.questionspertopic"
                    min="5"
                    max="10"
                    step="1"
                  ></b-form-spinbutton>
                </b-form-group>

                <b-form-group
                  class="nested-form-group"
                  v-if="schedule.mode == 'Topic' && schedule.topics.length != 0"
                  label="Select Minutes per Question"
                  label-for="testmode"
                >
                  <b-form-spinbutton
                    id="modeque"
                    v-model="schedule.minutesperquestion"
                    min="1"
                    max="2.5"
                    step="0.25"
                  ></b-form-spinbutton>
                </b-form-group>

                <b-form-group>
                  <p class="fll">Choose Test Date</p>
                  <b-form-datepicker
                    v-model="schedule.testdate"
                    :min="new Date()"
                    placeholder="Choose a Date"
                    required
                  ></b-form-datepicker>
                </b-form-group>

                <b-form-group>
                  <p class="fll">Choose Test Time</p>
                  <b-form-timepicker
                    v-model="schedule.testtime"
                    locale="en"
                    required
                  ></b-form-timepicker>
                </b-form-group>

                <b-form-group>
                  <div class="text-center w-100">
                    <b-overlay
                      :show="scheduling"
                      rounded
                      opacity="0.6"
                      spinner-small
                      spinner-variant="primary"
                      class=""
                    >
                      <b-button
                        :disabled="state"
                        type="submit"
                        class="w-100 btn-add p-2"
                        >Add Schedule</b-button
                      >
                    </b-overlay>
                    <b-button
                      v-if="scheduling"
                      class="w-50 p-2 mt-3 btntxt"
                      variant="dark"
                      @click="stopschedule"
                    >
                      Cancel
                    </b-button>
                  </div>
                </b-form-group>
              </b-form-group>
            </form>
          </div>
        </template>
      </b-modal>
      <!-- <b-row class="adhlg">
        <b-col>
          <div class="text-center p-3">
            <b-button v-b-modal.modal-schedule class="addbtn p-3">
              <b-icon-plus-circle-fill
                font-scale="1.3"
              ></b-icon-plus-circle-fill>
              Add Schedule
            </b-button>
          </div>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col>
          <b-overlay
            :show="
              plan == 'Free' && details.trial <= 0 &&
                details.clearance_organization != 'Quicktest'
            "
            opacity="0.7"
            spinner-variant="dark"
            spinner-small
            rounded
          >
            <template v-slot:overlay>
              <b-link :to="{ name: 'upgrade' }">
                <div class="text-center mt-4 w-100">
                  <p>
                    <b-icon-lock-fill
                      variant="warning"
                      font-scale="2"
                    ></b-icon-lock-fill>
                    Upgrade to Unlock
                  </p>
                </div>
              </b-link>
            </template>
            <div class="flex-div">
              <div class="left-flex-child">
                <div class="l-content"></div>
              </div>
              <div class="right-flex-child text-right mt-4 mb-2">
                <b-button
                  class="v-button p-lg-2"
                  v-b-modal.modal-schedule
                  variant="success"
                  >Schedule a Test</b-button
                >
              </div>
            </div>
          </b-overlay>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="schwrapper mt-2 p-4 pt-2">
            <span class="bcohe">Upcoming Schedules</span> <br />
            <span class="scohe">{{ schedulesup.length }} Tests Upcoming</span>
            <b-skeleton-wrapper
              class="text-center mt-3"
              :loading="schedulesup.length <= 0 && upschedulesfetched == false"
            >
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </template>
            </b-skeleton-wrapper>
            <up-schedules
              v-for="(schedule, index) in useschedulesup"
              :key="index"
              :schedule="schedule"
              type="up"
              from="moreresults"
            ></up-schedules>
            <div class="text-center vmore">
              <b-row>
                <b-col class="text-left p-0 m-0">
                  <p>
                    Showing {{ intervalnum2 * pages2 - intervalnum2 + 1 }} -
                    {{ endnum2 > endssup ? endssup : endnum2 }}
                  </p>
                </b-col>
                <b-col class="text-right p-0 m-0 button-pager-group">
                  <b-button-group size="xs">
                    <b-button
                      v-for="(page, index) in ranger2"
                      :key="index"
                      :page="page"
                      :class="[pages2 == page ? 'active-page-btn' : '']"
                      @click="newPage2(page)"
                      class="ml-1 page-buttons"
                      size="xs"
                      variant="outline-dark"
                      >{{ page }}</b-button
                    >
                  </b-button-group>
                </b-col>
              </b-row>
              <!-- <div class="viewmore" @click="showMore">
                  <b-icon-chevron-down font-scale="2" class="mt-3" animation="cylon-vertical">View More</b-icon-chevron-down>
              </div>
              <p class="p-1 m-1 textboldsf">Show More</p> -->
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <div class="schwrapper mt-2 p-4 pt-2">
            <span class="bcohe">Past Schedules</span> <br />
            <span class="scohe">{{ schedulespast.length }} Tests Past</span>
            <b-skeleton-wrapper
              class="text-center mt-3"
              :loading="
                schedulespast.length <= 0 && pastschedulesfetched == false
              "
            >
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </template>
            </b-skeleton-wrapper>
            <up-schedules
              v-for="(schedule, index) in useschedulespast"
              :key="index"
              :schedule="schedule"
              type="past"
              from="moreresults"
            ></up-schedules>
            <div class="text-center vmore">
              <b-row>
                <b-col class="text-left p-0 m-0">
                  <p>
                    Showing {{ intervalnum * pages - intervalnum + 1 }} -
                    {{ endnum > endss ? endss : endnum }}
                  </p>
                </b-col>
                <b-col class="text-right p-0 m-0 button-pager-group">
                  <b-button-group size="xs">
                    <b-button
                      v-for="(page, index) in ranger"
                      :key="index"
                      :page="page"
                      :class="[pages == page ? 'active-page-btn' : '']"
                      @click="newPage(page)"
                      class="ml-1 page-buttons"
                      size="xs"
                      variant="outline-dark"
                      >{{ page }}</b-button
                    >
                  </b-button-group>
                </b-col>
              </b-row>
              <!-- <div class="viewmore" @click="showMore">
                    <b-icon-chevron-down font-scale="2" class="mt-3" animation="cylon-vertical">View More</b-icon-chevron-down>
                </div>
                <p class="p-1 m-1 textboldsf">Show More</p> -->
            </div>
          </div>
        </b-col>
        <b-modal
          centered
          id="inlinemodal"
          title="Schedule Added"
          hide-footer
          button-size="lg"
        >
          <div>
            <p>Schedule Added Successfully.</p>
            <!-- <a :href="callink" class="lba text-center mx-auto"><b-button class="p-2" @click="downloaded = true" variant="success">Add to Calendar</b-button></a> -->
            <div class="text-center">
              <a
                :href="callink"
                class="lba text-center mx-auto p-2"
                target="_blank"
                download
                >Add to Calendar</a
              >
            </div>
          </div>
          <p v-if="downloaded">
            Click on the downloaded Calendar file to add to your calendar.
          </p>
        </b-modal>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
//import pastSchedules from '@/components/pastSchedules'
import upSchedules from "@/components/upSchedules";
//import { LocalNotifications } from "@capacitor/local-notifications"
import store from "@/store";

export default {
  components: {
    //pastSchedules,
    upSchedules
  },
  data() {
    let now = new Date();
    return {
      downloaded: false,
      curD: new Date(),
      tvalue: now.toTimeString().slice(0, 8),
      schedule: this.getForm(),
      bo: "",
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      limitnum2: this.endss,
      intervalnum2: 10,
      endnum2: 10,
      btnrange: this.endss,
      pages: 1,
      pages2: 1,
      btnrange2: this.endss,
      startnum2: 0,
      categoryarray: [],
      institutionsarray: [],
      coursesarray: [],
      levelsarray: [],
      subjectsarray: [],
      testmodearray: [
        { value: "Prototype", text: "Prototype Mode (default)" },
        { value: "Speed", text: "Speed Mode" },
        { value: "Accuracy", text: "Accuracy Mode" },
        { value: "Flexible", text: "Flexible Mode" },
        { value: "Topic", text: "Topic Mode", disabled: true }
      ],
      scheduleadded: false,
      scheduling: false,
      cheked: "WE are testing",
      callink: "",
      org: "Quicktest",
      structure: "",
      sameName: ""
    };
  },

  created() {
    if (this.details.plan == "Free" && (this.details.trial > 0 || this.details.clearance_organization != 'Quicktest')) {
      let typesarr = this.Categories.map(x => x.name);
      this.categoryarray = typesarr;
    }
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("dashboard/upSchedules");
    store.dispatch("dashboard/pastSchedules");

    next();
  },

  mounted() {
    // setInterval(this.settvalue, 1000);
    if (this.plan == "Premium") {
      this.categoryarray = this.premium.category;
      this.institutionsarray = this.premium.institutions;
      this.levelsarray = this.premium.levels;
    }else if(this.details.plan == "Free" && (this.details.trial <= 0 && this.details.clearance_organization == 'Quicktest')) {
      let typesarr = this.Categories.map(x => x.name);
      this.categoryarray = typesarr;
    }
  },

  methods: {
    settvalue() {
      let n = new Date();
      let ntime = n.toTimeString().slice(0, 8);

      this.tvalue = ntime;
    },
    getForm() {
      return {
        fname: this.$store.state.loginmaster.details.fullname,
        organization: this.$store.state.loginmaster.details.quicktest_details.organization_name,
        organization_id: this.$store.state.loginmaster.details.quicktest_details.track_id,
        category: null,
        structure: "",
        institution: null,
        institution_id: null,
        level: null,
        course: null,
        mode: "Prototype",
        subjects: [],
        testdate: "",
        testtime: "",
        environ: "",
        origin: "",
        topics: [],
        reducer: 25,
        questionspertopic: 5,
        minutesperquestion: 1,
        candidate: this.$store.state.loginmaster.details,
        email: this.$store.state.loginmaster.details.email
      };
    },
    addSched() {
      this.setloader();
      this.schedule.environ = this.environ;
      this.schedule.origin = this.origin;
      this.addSchedule(this.schedule).then(response => {
        this.upSchedules();
        this.pastSchedules();

        this.callink = response.data.callink;
        this.scheduling = false;
        this.scheduleadded = true;
        this.$bvModal.show("inlinemodal");
        this.schedule.category = null;
        this.schedule.institution = null;
        this.schedule.subjects = [];
        this.schedule.topics = [];
        this.schedule.level = null;
        this.schedule.course = null;
        this.schedule.reducer = 25;
        this.structure = "";
        this.schedule.testdate = "";
        this.schedule.testtime = "";
        //console.log(response.data.callink)
      });
    },
    setloader() {
      this.scheduling = true;
    },

    categoryChanged() {
      this.schedule.institution = null; // If the type is changed, reset the schedule Object. set the institution property to null
      this.schedule.subjects = []; // Empty the subjects property Array
      this.institutionsarray = []; // Empties the Institutions Array
      this.subjectsarray = [];
      this.schedule.mode = "Prototype"; // Set it to the default mode

      if (this.plan == "Free" && (this.details.trial > 0 || this.details.clearance_organization == 'Quicktest') ) {
        // alert(this.details.trial)
        // alert(this.org)
        let inst = this.allinsti
          .filter(
            x =>
              x.available == "Yes" &&
              x.category == this.schedule.category &&
              x.organization_name == this.org
          )
          .map(x => x.name);
        this.institutionsarray = inst;
        // console.log(inst)
      } else {
        this.institutionsarray = this.premium.institutions;
      }

      // let inst = this.allinsti.filter((x) => x.available == "Yes" && x.category == this.schedule.category && x.organization_name == this.org).map((x) => x.name);

      // // console.log(inst)
      // this.institutionsarray = inst;

      this.schedule.organization = this.org;
      let tabi = this.Categories.filter(
        x => x.organization_name == this.org && x.name == this.schedule.category
      ).map(x => x.structure);
      this.structure = tabi[0];
      this.schedule.structure = this.structure;

      let sameName = this.Categories.filter(
        x => x.organization_name == this.org && x.name == this.schedule.category
      ).map(x => x.sameName);
      this.sameName = sameName[0];

      if (this.sameName == "Yes") {
        this.schedule.institution = this.schedule.category;
        let unparsedSubjects = this.allinsti
          .filter(
            x =>
              x.name == this.schedule.category &&
              x.organization_name == this.org
          )
          .map(x => x.subjects_offered);
        this.subjectsarray = JSON.parse(unparsedSubjects);

        // Get the Compulsory Subjects array
        let unparsedCompulsorySubjects = this.allinsti
          .filter(
            x =>
              x.name == this.schedule.institution &&
              x.organization_name == this.org
          )
          .map(x => x.compulsory_subjects);

        // Parse the Compulsory Subjects Array
        let parsedCompulsorySubjects = JSON.parse(unparsedCompulsorySubjects);

        parsedCompulsorySubjects.forEach(subject => {
          // If 'all' is the value in the Compulsory subject array, then it means all the subjects are compulsory
          // Therefore push all the subjects in the 'subjectsarray' into the 'subject' property of the select Object
          if (subject.toLowerCase() == "all") {
            this.subjectsarray.forEach(subject2 => {
              this.schedule.subjects.push(subject2);
            });
          } else {
            // Push the items in the Compulsory Array one by one into the 'subject' property of the select Object
            this.schedule.subjects.push(subject);
          }
        });
      }
    },

    institutionChanged() {
      this.levelsarray = []; // Anytime user changes Institution, empty the levelsarray
      this.schedule.institution_shortname = this.allinsti.find(
        x => x.name == this.schedule.institution && this.schedule.category == x.category
      ).short_name;

      let institution_id = this.allinsti
        .filter(
          x =>
            x.category == this.schedule.category &&
            x.name == this.schedule.institution &&
            x.organization_name == this.org
        )
        .map(x => x.track_id);
      this.schedule.institution_id = institution_id[0];
      // If the selected category to be taken is undergraduate
      if (this.structure == "Section") {
        // Get the levels config Object for this particular institution under the undergraduate category
        // The Levels Configuration Object contains all the Configuration for each level and courses available under the selected institution
        let unparsedLevelConfig = this.allinsti
          .filter(
            x =>
              x.category == this.schedule.category &&
              x.name == this.schedule.institution
          )
          .map(x => x.levels_config);
        let parsedLevelConfig = JSON.parse(unparsedLevelConfig); // Parse the levels config from string
        this.schedule.subjects = []; // Clear the subject property of the select Object anytime the user changes Institution

        if (this.plan != "Premium") {
          // Get the name of each level available in the levels config. It should return "['100', '200']" depending on the levels available in the Configurations Object
          this.levelsarray = parsedLevelConfig.map(x => x.name);
        } else {
          // If User is Premium, get the level(s) the user is operating premium on
          this.levelsarray = this.premium.levels;
        }
      } else {
        // Get the Subjects available for this Institution from the Institutions Object and map them to 'unparsedSubjects'
        let unparsedSubjects = this.allinsti
          .filter(
            x =>
              x.name == this.schedule.institution &&
              x.category == this.schedule.category
          )
          .map(x => x.subjects_offered);
        this.subjectsarray = JSON.parse(unparsedSubjects); // parse the Array and set the value of the data property 'subjectsarray' to it
        this.schedule.subjects = []; // Clear the subject property of the select Object anytime the user changes Institution
        // Get the Compulsory Subjects array
        let unparsedCompulsorySubjects = this.allinsti
          .filter(
            x =>
              x.name == this.schedule.institution &&
              x.category == this.schedule.category
          )
          .map(x => x.compulsory_subjects);
        // Parse the Compulsory Subjects Array
        // console.log(unparsedCompulsorySubjects)
        let parsedCompulsorySubjects = JSON.parse(unparsedCompulsorySubjects);
        // console.log(parsedCompulsorySubjects)
        let subjectsarray = JSON.parse(unparsedSubjects);

        // Loop through the Compulsory Array and perform a function for each Function
        parsedCompulsorySubjects.forEach(subject => {
          // If 'all' is the value in the Compulsory subject array, then it means all the subjects are compulsory
          // Therefore push all the subjects in the 'subjectsarray' into the 'subject' property of the select Object
          if (subject.toLowerCase() == "all") {
            subjectsarray.forEach(subject2 => {
              this.schedule.subjects.push(subject2);
            });
          } else {
            // Push the items in the Compulsory Array one by one into the 'subject' property of the select Object
            this.schedule.subjects.push(subject);
          }
        });
      }
    },

    newPage(page) {
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    },

    newPage2(page) {
      this.pages2 = page;
      let newend = this.intervalnum2 * page;

      if (newend < this.endssup) {
        this.endnum2 = newend;
        this.startnum2 = newend - this.intervalnum2;
      } else {
        this.endnum2 = this.endssup;
        this.startnum2 = newend - this.intervalnum2;
      }
    },
    chgcourses() {
      // Get the Whole Config Object of the selected Undergraduate Institution
      let levell = this.allinsti
        .filter(
          x =>
            x.category == this.schedule.category &&
            x.name == this.schedule.institution
        )
        .map(x => x.levels_config);

      let reallevell = JSON.parse(levell);

      // Get the Chosen Level exact config Array
      let config = reallevell
        .filter(x => x.name == this.schedule.level)
        .map(x => x.config);
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let courses = config[0]
        .filter(x => x.name == "courses")
        .map(x => x.values);

      // Inject this Array into the general courses Array for Selection
      this.coursesarray = courses[0];
    },
    topicMode() {
      if (this.schedule.mode == "Topic") {
        let categoryconfig = this.Categories.filter(
          x => x.name == this.schedule.category
        );

        if (categoryconfig[0].structure == "Section") {
          let currentTopics = this.alltopics
            .filter(
              x =>
                x.topic_for == this.schedule.course &&
                x.institution == this.schedule.institution &&
                x.category == this.schedule.category
            )
            .map(x => x.topic);

          this.topicsarray = currentTopics;
        } else if (categoryconfig[0].structure == "Subject") {
          let currentTopics = this.alltopics
            .filter(
              x =>
                x.topic_for == this.schedule.subjects[0] &&
                x.institution == this.schedule.institution &&
                x.category == this.schedule.category
            )
            .map(x => x.topic);

          this.topicsarray = currentTopics;
        }
      }
    },
    stopschedule() {
      this.scheduling = false;
    },
    ...mapActions("dashboard", ["addSchedule", "upSchedules", "pastSchedules"]),
    ...mapActions("exam", ["retrieveInstitutions"])
  },
  computed: {
    ...mapState({
      plan: state => state.loginmaster.details.plan,
      details: state => state.loginmaster.details,
      premium: state => state.loginmaster.details.premium_details,
      schedulesup: state => state.dashboard.upschedules,
      schedulespast: state => state.dashboard.pastschedules,
      upschedulesfetched: state => state.dashboard.upschedulesfetched,
      pastschedulesfetched: state => state.dashboard.pastschedulesfetched,
      allinsti: state => state.exam.allinstitutions,
      Categories: state => state.exam.allcategories,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.site_origin
    }),
    state() {
      if (
        this.schedule.category == null ||
        this.schedule.institution == null ||
        this.schedule.testdate.length == 0 ||
        this.schedule.testtime.length == 0 ||
        !this.substate
      ) {
        return true;
      } else {
        return false;
      }
    },
    useschedulespast() {
      return this.schedulespast.slice(this.startnum, this.endnum);
    },
    useschedulesup() {
      return this.schedulesup.slice(this.startnum2, this.endnum2);
    },
    endss() {
      let end = this.schedulespast.length;
      return end;
    },
    endssup() {
      let end = this.schedulesup.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(this.schedulespast.length / this.intervalnum);
      return ranger;
    },
    ranger2() {
      let ranger = Math.ceil(this.schedulesup.length / this.intervalnum2);
      return ranger;
    },
    substate() {
      if (this.schedule.mode == "Topic") {
        if (this.structure != "Section") {
          // Checks if the number of subjects picked is the same as the number of Subjects required for this exam and if all fields has been selected
          return this.schedule.subjects.length == 1
            ? true
            : (false && this.schedule.institution == null) || this.proceeding;
        } else {
          // Checks if all required fields has been selected
          return (
            (this.schedule.level != null && this.schedule.course != null) ||
            this.proceeding
          );
        }
      } else {
        if (this.structure != "Section") {
          // Checks if the number of subjects picked is the same as the number of Subjects required for this exam and if all fields has been selected
          return this.schedule.subjects.length ==
            this.allinsti
              .filter(x => x.name == this.schedule.institution)
              .map(x => x.num_courses)[0]
            ? true
            : (false && this.schedule.institution == null) || this.proceeding;
        } else {
          // Checks if all required fields has been selected
          return (
            (this.schedule.level != null && this.schedule.course != null) ||
            this.proceeding
          );
        }
      }
    },
    substate2() {
      return this.schedule.topics.length == 0 ? false : true;
    },

    numberofSubjects() {
      // returns the number of subjects required for the selected institution
      return this.allinsti
        .filter(
          x =>
            x.name == this.schedule.institution &&
            x.category == this.schedule.category
        )
        .map(x => x.num_courses)[0];
    }
  }
};
</script>

<style scoped>
.schwrapper {
  background-color: white;
  border-radius: 20px 20px;
  /* min-height: 70vh; */
}

.bcohe {
  font-size: 1.5rem;
  font-weight: bold;
}

.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}

.scohe {
  font-size: 1.2rem;
}

.twrap {
  background-color: white;
  border-radius: 20px 20px;
  min-height: 30vh;
}

.addbtn {
  border-radius: 30px 30px;
  background-color: #00377b;
  font-size: 1.2rem;
  font-weight: bold;
  box-shadow: 1px 1px 8px black;
}

.btn-add {
  background-color: #00377b;
  font-size: 1.3rem;
  font-weight: bolder;
}

.btn-add:hover {
  background-color: rgba(24, 24, 214, 0.721);
}
.lba {
  display: inline-block;
  background-color: #00984a;
  color: white;
  width: 200px;
  font-size: 1.2rem;
  font-weight: bold;
  text-decoration: none;
  border-radius: 10px 10px;
  cursor: pointer;
}
.lba:hover {
  text-decoration: none;
}
.vmore {
  margin: 5px;
  padding: 10px;
}

.page-buttons {
  width: 35px;
  height: 35px;
}
.active-page-btn {
  background-color: #00377b;
  color: white;
}

.v-button {
  border-radius: 10px 10px;
  width: 10rem;
  height: 3rem;
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}
.button-pager-group {
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: thin;
}

@media screen and (max-width: 999px) {
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
  .v-button {
    width: fit-content;
    height: 2.5rem;
  }
}

@media (min-width: 768px) {
  .adhlg {
    display: none;
  }
}
</style>
